import {EmptyOutput} from "../api/values/empty-output";
import {PasswordResetInput} from "../api/values/password-reset-input";
import {PasswordResetRequestInput} from "../api/values/password-reset-request-input";
import {getServerUrl} from "./global-config";
import {requestObject} from "./http-request";

export async function requestPasswordReset(email: string) {
    // TODO: routesから取りたい
    const adminUrl = location.origin + "/admin/password-reset";
    await requestObject(
        "POST",
        "/api/password-reset",
        EmptyOutput,
        undefined,
        new PasswordResetRequestInput({
            email,
            adminURL: adminUrl,
        }),
        {baseUrl: getServerUrl()},
    );
}

export async function passwordReset(resetToken: string, newPassword: string) {
    await requestObject(
        "POST",
        `/api/password-reset/${resetToken}`,
        EmptyOutput,
        undefined,
        new PasswordResetInput({newPassword}),
        {baseUrl: getServerUrl()},
    );
}
